import {setScrollTo} from './anchor.js';

function scrollToBottom() {

    if (document.querySelector('.js-job-offer-btn')) {
        document.querySelector('.js-job-offer-btn').addEventListener('click', (event) => {
            event.preventDefault();
            setScrollTo(document.querySelector('.js-job-offer-dest'));
        });
    }
}

export default scrollToBottom;



// WEBPACK FOOTER //
// ./src/main/js/components/jobOffer.js